import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import {
  MockModalContainer,
  MockModalHeader,
  SMSLable,
  SMSTime,
  MockModalContent,
  MockModalTitle,
  MockModalText,
} from './style'

const NotificationModal = ({ type, sender, emailTitle, content, isResend }) => {
  const [isDisplay, setDisplay] = useState(false)
  const [isDisplayed, setDispalyed] = useState(false)
  if (!isDisplay && !isDisplayed) {
    setTimeout(() => setDisplay(true), 300)
    setDispalyed(true)
  }
  if (isDisplay) {
    setTimeout(() => setDisplay(false), 2000)
  }
  useEffect(() => {
    if (isResend) {
      setDispalyed(false)
    }
  }, [isResend])

  return (
    <MockModalContainer showModal={isDisplay}>
      <MockModalHeader>
        <SMSLable type={type}>{type === 'SMS' ? 'MESSAGES' : 'MAIL'}</SMSLable>
        <SMSTime>now</SMSTime>
      </MockModalHeader>
      <MockModalContent>
        <MockModalTitle>{sender}</MockModalTitle>
        {emailTitle && <MockModalTitle>{emailTitle}</MockModalTitle>}
        {content &&
          content.map((item, index) => (
            <MockModalText key={index}>{item}</MockModalText>
          ))}
      </MockModalContent>
    </MockModalContainer>
  )
}
NotificationModal.propTypes = {
  title: PropTypes.string,
  content: PropTypes.array,
  sender: PropTypes.string,
  type: PropTypes.oneOf(['SMS', 'Email']),
}

export default NotificationModal
